module.exports = __webpack_public_path__ + "components/flag/static/square/fk-cf8a71272dd8ce4ac010da6c02bfca60.svg";